import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { LoadingService } from '../shared/loading/loading.service';
import { AlertService } from '../shared/alerts/alerts.service';
import { EventsService } from '../shared/events/events.service';
import { OtpService } from './otp.service';


@Component({
    selector: 'my-otp',
    template: require('./otp.component.html'),
    styles: [require('./otp.component.scss'), require('../shared/styles/form.scss')]
})
export class OtpComponent implements OnInit {
    @Input() userId: string;
    @Output()
    private formReady: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    private token: string;
    public otpSent: boolean;
    public canResend: boolean;
    public otpForm: FormGroup;
    private resetTimer$: Observable<any>;

    constructor(
        private loadingService: LoadingService,
        public alertService: AlertService,
        public eventsService: EventsService,
        private route: ActivatedRoute,
        private otpService: OtpService
    ) {
        this.otpSent = false;
        this.canResend = false;
        this.otpForm = new FormGroup({
            otp: new FormControl()
        });
    }

    error(error: any): any {
        this.loadingService.hideLoading();
        let data;
        try {
            data = JSON.parse(error._body);
        } catch (e) { }

        let errMsg = (data && (data.message || data.error)) || 'Error Occurred.';
        this.alertService.createAlert(true, true, errMsg);
    }

    success(data) {
        this.alertService.createAlert(true, false, data.message);
    }

    successVerifyOtp(data) {
        this.eventsService.broadcast('otpVerified');
        this.success(data);
    }

    successSendOtp(data) {
        this.canResend = false;
        const countdown = 30;

        this.resetTimer$ = Observable.timer(0, 1000).map(i => countdown - i).take(countdown + 1);

        this.resetTimer$.subscribe(_ => { }, _ => { },
            () => {
                this.canResend = true;
                this.resetTimer$ = null;
            });
        this.success(data);
    }

    sendOtp() {
        let params;
        if (this.userId) {
            params = { userId: this.userId };
        } else {
            params = { resetToken: this.token };
        }
        this.otpSent = true;
        this.otpService.generateOtp(params).subscribe((data) => this.successSendOtp(data), err => this.error(err));
    }

    verifyOtp() {
        let params = { otp: this.otpForm.controls.otp.value };
        this.otpService.verifyOtp(params).subscribe((data) => this.successVerifyOtp(data), err => this.error(err));
    }

    ngOnInit() {
        this.formReady.emit(this.otpForm);
        this.loadingService.showLoading();
        this.route.queryParams
            .subscribe(params => {
                this.token = params['token'] || '';
                this.loadingService.hideLoading();
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/otp/otp.component.ts